const GA_ID = 'G-QW9WY8K43G';

function gtag(...args) {
  if (typeof window.gtag === 'function') {
    window.gtag(...args);
  }
}

// ── Page view ──────────────────────────────────────
export function trackPageView() {
  gtag('config', GA_ID, {
    page_title: document.title,
    page_location: window.location.href,
  });
}

// ── CTA clicks ────────────────────────────────────
export function trackCTAClick(buttonText, location) {
  gtag('event', 'cta_clicked', {
    button_text: buttonText,
    location,
  });
}

// ── Menu ──────────────────────────────────────────
export function trackMenuOpen() {
  gtag('event', 'menu_opened');
}

export function trackMenuClose() {
  gtag('event', 'menu_closed');
}

export function trackMenuLinkClick(label) {
  gtag('event', 'menu_link_clicked', { label });
}

// ── Section viewed ────────────────────────────────
export function trackSectionView(sectionName) {
  gtag('event', 'section_viewed', { section_name: sectionName });
}

// ── Scroll depth ──────────────────────────────────
// Fires once each at 25 / 50 / 75 / 90 / 100 %
export function initScrollDepth() {
  const milestones = [25, 50, 75, 90, 100];
  const fired = new Set();

  function getPercent() {
    const el = document.documentElement;
    const scrolled = el.scrollTop || document.body.scrollTop;
    const total = el.scrollHeight - el.clientHeight;
    return total > 0 ? Math.round((scrolled / total) * 100) : 0;
  }

  function onScroll() {
    const pct = getPercent();
    milestones.forEach(m => {
      if (pct >= m && !fired.has(m)) {
        fired.add(m);
        gtag('event', 'scroll_depth', { percent_scrolled: m });
      }
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  return () => window.removeEventListener('scroll', onScroll);
}

// ── Section visibility (IntersectionObserver) ─────
// Fires once when each section enters viewport at ≥30%
const SECTIONS = [
  { id: 'top',        name: 'hero'          },
  { id: 'philosophy', name: 'philosophy'    },
  { id: 'obsession',  name: 'obsession'     },
  { id: 'services',   name: 'what_we_build' },
  { id: 'process',    name: 'process'       },
  { id: 'work',       name: 'projects'      },
  { id: 'contact',    name: 'contact_cta'   },
];

export function initSectionTracking() {
  const seen = new Set();

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const name = entry.target.dataset.section;
        if (name && !seen.has(name)) {
          seen.add(name);
          trackSectionView(name);
        }
      });
    },
    { threshold: 0.3 }
  );

  SECTIONS.forEach(({ id, name }) => {
    const el = document.getElementById(id);
    if (el) {
      el.dataset.section = name;
      observer.observe(el);
    }
  });

  return () => observer.disconnect();
}

// ── Time on page ──────────────────────────────────
// Fires at 30s, 60s, 120s, 300s
export function initTimeOnPage() {
  const checkpoints = [30, 60, 120, 300];
  const timers = checkpoints.map(seconds =>
    setTimeout(() => {
      gtag('event', 'time_on_page', { seconds });
    }, seconds * 1000)
  );
  return () => timers.forEach(clearTimeout);
}
